import React from 'react'
import ActionButtons from 'redesign/components/organisms/action-buttons'
import type { TaskDetailsComponentProps } from '../task-details/types'
import { useActionButtons } from './hooks/use-action-buttons'

const TaskDetailsActionButtons: React.FC<TaskDetailsComponentProps> = ({
  task,
  refetch,
  workflowPermissions,
  prevMonthTask,
  timelineItems,
  setShowAbsenceForm,
  onDelete,
}) => {
  const [timelineItem] = timelineItems ?? []
  const { mainActions, hiddenActions } = useActionButtons({
    task,
    refetch,
    workflowPermissions,
    prevMonthTask,
    timelineItem,
    setShowAbsenceForm,
    onDelete,
  })

  return <ActionButtons mainActions={mainActions} hiddenActions={hiddenActions} />
}

export default TaskDetailsActionButtons
